module.exports = __webpack_public_path__ + "img/logo.ac9408ba.png";